module.exports = __webpack_public_path__ + "static/media/img_2.2c137d3f.jpg";